import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const departmentApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listDepartments: builder.query({
            query: (includeDisabled) => ({
                url: `department/list?includeDisabled=${includeDisabled? includeDisabled : false}`,
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('Department', result)
        }),
        getDepartment: builder.query({
            query: (id) => `department/${id}`,
            providesTags: (result, error, id) => [{ type: 'Department', id }]
        }),
        createDepartment: builder.mutation({
            query: (data) => ({
                url: 'department/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'Department', id: 'LIST' }]
        }),
        updateDepartment: builder.mutation({
            query: ({id, ...data}) => ({
                url: `department/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getDepartment'),
            invalidatesTags: [{ type: 'Department', id: 'LIST' }]
        })
    })
});

export const {
    useListDepartmentsQuery,
    useGetDepartmentQuery,
    useCreateDepartmentMutation,
    useUpdateDepartmentMutation
} = departmentApi;